import { Outlet, createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'

import { AppManagerFetch } from '@/app/AppManagerFetch'
import { AppManagerIdentify } from '@/app/AppManagerIdentify'
import { AppManagerScorm } from '@/app/AppManagerScorm'
import { AppManagerSSO } from '@/app/AppManagerSSO'

export const Route = createFileRoute('/signup')({
  validateSearch: v.object({
    lang: v.optional(v.string()),
  }),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <AppManagerSSO>
      <AppManagerFetch>
        <AppManagerScorm>
          <AppManagerIdentify>
            <Outlet />
          </AppManagerIdentify>
        </AppManagerScorm>
      </AppManagerFetch>
    </AppManagerSSO>
  )
}
